export default "__VITE_ASSET__Dk2h7_mz__"